import { render, staticRenderFns } from "./PlantioMarker.vue?vue&type=template&id=63dd2abf&scoped=true"
import script from "./PlantioMarker.vue?vue&type=script&lang=js"
export * from "./PlantioMarker.vue?vue&type=script&lang=js"
import style0 from "./PlantioMarker.vue?vue&type=style&index=0&id=63dd2abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd2abf",
  null
  
)

export default component.exports